import pluralize from "pluralize"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { ItemCountBadgeProps } from "./ItemCountBadge.types"

const icon = faIcon({ name: "box-taped", style: "regular" })

export default function ItemCountBadge(props: ItemCountBadgeProps) {
    const { count, size = "md" } = props

    // Always rendered — shows "0 items" when the object has no line items.
    const label = pluralize("item", count, true)

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={`Line items\n${count}`}>
            {label}
        </Badge>
    )
}
